var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001,
    viewBox: "0 0 16 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M51,270v-5h5v5Zm-6,0v-4.92h4.92V270Zm12,0v-5l4,.077V270Zm-1-6v-5h5v5Zm-6,0v-5h5v5Zm-5,0v-5h4v5Zm0-6v-4H61v4Z",
    transform: "translate(-45 -253.999)",
    fill: "#aaa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.036ba4a4.svg";
export { ForwardRef as ReactComponent };